const TELEGRAM_INIT_DATA_KEY = 'telegramInitData';

export function persistSuperInitData(): void {
  const encoded = new URLSearchParams(window.location.search).get('super_init_data');
  if (!encoded) return;

  try {
    const decoded = atob(encoded);
    if (decoded) {
      localStorage.setItem(TELEGRAM_INIT_DATA_KEY, decoded);
    }
  } catch {
    // Fanton authentication will reject malformed init data without replacing
    // a previously stored valid session.
  }
}
